import { Status } from '@sunbit-dev/purchase-common/src/enums/guided-app/Status';
import URLs from '~/enums/URLs';

export const getUrlPathByStatus = ({ status }: { status: Status }) => {
  switch (status) {
    case Status.Created:
    case Status.ConfirmCustomerDetails:
    case Status.LinkWasSentToCustomer:
    case Status.LinkWasOpened:
      return URLs.CustomerDetails;
    case Status.RequestToCheckout:
    case Status.RequestToCheckoutUpdated:
    case Status.RequestToCheckoutApproved:
      return URLs.PurchaseAmountPending;
    case Status.Declined:
    case Status.ChargeFailed:
    case Status.ChoosePaymentPlan:
    case Status.SessionExpiredWhileChoosePaymentPlan:
    case Status.CustomerPreQualified:
    case Status.PaymentDetails:
    case Status.Agreement:
    case Status.FinalReview:
    case Status.ExtraVerification:
    case Status.CreditFreeze:
      return URLs.OptionsLoading;
    case Status.EstimateOnly:
      return URLs.EstimateThankYou;
    case Status.ChargeInProgress:
    case Status.ChargeApplied:
      return URLs.ProcessingPayment;
    case Status.PostChargeSucceeded:
    case Status.Completed:
      return URLs.Thanks;
    case Status.PostChargeFailed:
      return URLs.PostChargeFailed;
    case Status.CanceledByRetailer:
    case Status.CanceledByCustomer:
    case Status.Expired:
      return URLs.LinkExpired;
    default:
      console.error(`Status URL "${status}" does not exist!`);
  }
};
